import { render, staticRenderFns } from "./gd-dlysjg-true-hazard-events.vue?vue&type=template&id=50281682&scoped=true"
import script from "./gd-dlysjg-true-hazard-events.vue?vue&type=script&lang=js"
export * from "./gd-dlysjg-true-hazard-events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50281682",
  null
  
)

export default component.exports